// extracted by mini-css-extract-plugin
export var author = "blog-post-module--author--35f9e";
export var authorDesktop = "blog-post-module--author-desktop--91624";
export var authorMobile = "blog-post-module--author-mobile--84a6f";
export var blogPostArticle = "blog-post-module--blog-post-article--956b6";
export var category = "blog-post-module--category--9c121";
export var description = "blog-post-module--description--14c42";
export var header = "blog-post-module--header--e9a9a";
export var headline = "blog-post-module--headline--cf529";
export var headlinePost = "blog-post-module--headline-post--9501a";
export var image = "blog-post-module--image--57e42";
export var paragraph = "blog-post-module--paragraph--635b8";
export var section = "blog-post-module--section--b1202";
export var title = "blog-post-module--title--ba23d";